import React, { useState, useEffect } from 'react'
import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'

export function NotificationPermissionBanner() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (typeof Notification !== 'undefined' && Notification.permission === 'default') {
      setVisible(true)
    }
  }, [])

  if (!visible) return null

  function handleEnable() {
    Notification.requestPermission().then(() => {
      setVisible(false)
    })
  }

  return (
    <Alert
      severity="info"
      action={
        <>
          <Button size="small" onClick={handleEnable}>Enable</Button>
          <Button size="small" onClick={() => setVisible(false)}>Dismiss</Button>
        </>
      }
      sx={{ mb: 2 }}
    >
      Enable notifications to get alerts when tasks need your attention.
    </Alert>
  )
}
